import * as React from 'react';
import Adsense from './components/AdSense';

import './Footer.component.scss';

/* ----- Types ----- */

/* ----- Main Component ----- */
const Footer = () => (
  <div className="footer">
    <div className="footer__description">
      Does your brand feel hidden? Let{" "}
      <a href="https://www.dysrupt.com/" target="__blank">
        dysrupt
      </a>{" "}
      help your brand get seen. Click{" "}
      <a href="https://dysrupt.com/" target="__blank">
        Here
      </a>
      !
    </div>
    <Adsense client="ca-pub-9902877738977740" slot="3439755165" />
  </div>
);

export default Footer;
